import styled from 'styled-components';
import { animateIn, media } from '../../utils';

export const Wrapper = styled.article`
	position: relative; /* Crucial: anchors the absolute background inside this section */

	h1 {
		text-align: center;
	}
`;

export const Content = styled.div`
	${animateIn('0.1s')} /* Fades in almost instantly */
	position: relative;
	display: grid;
	align-items: center;
	justify-content: center;
	gap: var(--gap);
	max-width: 45rem;
	margin: auto;

	${media.medium`
		grid-template-columns: repeat(2, 1fr);
	`}
`;

export const FeaturedImg = styled.div`
	overflow: hidden;
	height: fit-content;
	background: var(--photoBg);
	padding: 0.3rem;
	position: relative;
	${animateIn('0.4s')} /* Fades in last */

	${media.medium`
		padding: 0.5rem;
	`}

	.gatsby-image-wrapper {
		height: auto;

		${media.small`
			height: auto;
		`}
	}
`;

export const Description = styled.p`
	margin-top: 0;
	${animateIn('0.25s')} /* Fades in slightly after */

	&:first-letter {
		font: normal 5rem var(--serif);
		float: left;
		margin: var(--lineHeight) var(--lineHeight) 0 0;
		line-height: 0.65;
		color: var(--photoBg);
	}

	a {
		margin-top: 1rem;
	}
`;
